import React, { useRef, useState } from "react";
import { useFormik } from "formik";
import Cookies from "js-cookie";
import { toast } from "react-toastify";
import Select from "react-select";
import * as Yup from "yup";
import { Table } from "antd";
// import { adminMainUrl } from '../../Config';
import Offcanvas from "react-bootstrap/Offcanvas";
import Accordion from "react-bootstrap/Accordion";
import { useNavigate, Link } from "react-router-dom";
// import { adminMainUrl } from '../../../../Config';
const AddMaster = ({ show, handleClose, onSuccess }) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const options = [
    { value: "chocolate", label: "Chocolate" },
    { value: "strawberry", label: "Strawberry" },
    { value: "vanilla", label: "Vanilla" },
  ];
  const closeButtonRef = useRef(null);
  const validationSchema = Yup.object({
    name: Yup.string().required("Name is required"),
    SCAC: Yup.string().required("SCAC is required"),
    alias: Yup.string().required("Alias is required"),
    accountNo: Yup.string().required("Account No is required"),
    homepageUrl: Yup.string().required("URL is required"),
    trackingUrl: Yup.string().required("URL is required"),
    bl_project: Yup.string().required("BL Project is required"),
  });

  // Initialize Formik
  const formik = useFormik({
    initialValues: {
      name: "", // Initial value for the RequiredService type
      SCAC: "",
      alias: "",
      accountNo: "",
      homepageUrl: "",
      trackingUrl: "",
      bl_project: "",
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      handleClose();
      formik.resetForm();
      setIsSubmitting(true);
      // try {
      //     const response = await fetch(`${adminMainUrl}/api/department/create`, {
      //         method: 'POST',
      //         headers: {
      //             'Content-Type': 'application/json',
      //             'auth-token': Cookies.get('token'), // Assuming token is stored in cookies
      //         },
      //         body: JSON.stringify(values),
      //     });

      //     const data = await response.json();

      //     if (response.ok) {
      //         // closeButtonRef.current.click();
      //         if (onSuccess) onSuccess();
      //         toast.success(data?.msg);
      //         handleClose()
      //         formik.resetForm();
      //     } else {
      //         toast.error(data?.msg);
      //         // Handle errors from the server
      //         console.error('Error creating RequiredService Type:', data.message);
      //     }
      // } catch (error) {
      //     console.error('Network error:', error);
      // }
      // finally {
      //     setIsSubmitting(false); // Stop the spinner
      // }
    },
  });
  const columns = [
    { title: "S. No.", dataIndex: "SNo", key: "SNo" },
    { title: "Charge Name", dataIndex: "ChargeName", key: "ChargeName" },
    { title: "Charge Code", dataIndex: "ChargeName", key: "ChargeName" },
    {
      title: "Airline Charge Code",
      dataIndex: "AirlineChargeCode",
      key: "AirlineChargeCode",
    },
    { title: "Action", dataIndex: "action", key: "action" },
  ];

  const dataSource = [
    {
      key: "1", // Add a unique key for each row
      SNo: "1", // Changed to camelCase
      ChargeName: "Commission", // Ensure date formatting as neede
      ChargeCode: "Commission",
      AirlineChargeCode: "Commission",
      action: (
        <div className="dropdown table-action">
          <Link to="#" className="action-icon" data-bs-toggle="dropdown">
            <i className="fa fa-ellipsis-v"></i>
          </Link>
          <div className="dropdown-menu dropdown-menu-right">
            <div className=" cursor-pointer">
              <i className="ti ti-edit text-blue"></i> Add
            </div>
            {/* <Link className="dropdown-item" to="#" data-bs-toggle="modal" data-bs-target="#delete_contact">
                              <i className="ti ti-trash text-danger"></i> Delete
                          </Link> */}
            {/* <div className="dropdown-item" onClick={() => { navigate('/flexichain/view-price-information', { state: { quotationId: value.id } }) }}>
                              <i className="ti ti-eye text-blue-light"></i> Preview
                          </div> */}
          </div>
        </div>
      ),
    },
    {
      key: "2", // Add a unique key for each row
      SNo: "2", // Changed to camelCase
      ChargeName: "Commission", // Ensure date formatting as neede
      ChargeCode: "Commission",
      AirlineChargeCode: "Commission",
      action: (
        <div className="dropdown table-action">
          <Link to="#" className="action-icon" data-bs-toggle="dropdown">
            <i className="fa fa-ellipsis-v"></i>
          </Link>
          <div className="dropdown-menu dropdown-menu-right">
            <div className=" cursor-pointer">
              <i className="ti ti-edit text-blue"></i> Edit
            </div>
            {/* <Link className="dropdown-item" to="#" data-bs-toggle="modal" data-bs-target="#delete_contact">
                              <i className="ti ti-trash text-danger"></i> Delete
                          </Link> */}
            {/* <div className="dropdown-item" onClick={() => { navigate('/flexichain/view-price-information', { state: { quotationId: value.id } }) }}>
                              <i className="ti ti-eye text-blue-light"></i> Preview
                          </div> */}
          </div>
        </div>
      ),
    },
  ];
  const ApplicableOption = [
    { value: "chocolate", label: "Chocolate" },
    { value: "strawberry", label: "Strawberry" },
    { value: "vanilla", label: "Vanilla" },
  ];

  return (
    <Offcanvas
      className="custom-offcanvas"
      show={show}
      onHide={handleClose}
      placement="end"
    >
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>Add CESS</Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <form onSubmit={formik.handleSubmit}>
          <div className="row">
            <div className="col-md-6">
              <div className="mb-2 ">
                <label htmlFor="name" className="form-label ">
                  
RITC Code <span style={{ color: "red" }}>*</span>
                </label>
                <div className="w-100">
                  <Select className="custom-selector" />
                  {formik.touched.name && formik.errors.name ? (
                    <div className="error">{formik.errors.name}</div>
                  ) : null}
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="mb-2 ">
                <label htmlFor="name" className="form-label ">
                Sr. No. <span style={{ color: "red" }}>*</span>
                </label>
                <div className="w-100">
                  <input
                    type="text"
                    className="form-control form-control-sm w-100"
                    id="alias"
                    name="alias"
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="mb-2 ">
                <label htmlFor="name" className="form-label ">
                  
                Flag <span style={{ color: "red" }}>*</span>
                </label>
                <div className="w-100">
                  <Select className="custom-selector" />
                  {formik.touched.name && formik.errors.name ? (
                    <div className="error">{formik.errors.name}</div>
                  ) : null}
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="mb-2 ">
                <label htmlFor="name" className="form-label ">
                Tariff Value <span style={{ color: "red" }}>*</span>
                </label>
                <div className="w-100">
                  <div className="d-flex justify-content-start align-items-center gap-1">
                    <input
                      type="text"
                      className="form-control form-control-sm w-100"
                      id="alias"
                      name="alias"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.alias}
                    />
                    <Select className="custom-selector" />
                  </div>
                  {formik.touched.alias && formik.errors.alias ? (
                    <div className="error">{formik.errors.alias}</div>
                  ) : null}
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="mb-2 ">
                <label htmlFor="name" className="form-label ">
                Cess / Duty Rate(in %) <span style={{ color: "red" }}>*</span>
                </label>
                <div className="w-100">
                  <input
                    type="text"
                    className="form-control form-control-sm w-100"
                    id="alias"
                    name="alias"
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="mb-2 ">
                <label htmlFor="name" className="form-label ">
                Cess / Duty Rate(in Rs)<span style={{ color: "red" }}>*</span>
                </label>
                <div className="w-100">
                  <div className="d-flex justify-content-start align-items-center gap-1">
                    <input
                      type="text"
                      className="form-control form-control-sm w-100"
                      id="alias"
                      name="alias"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.alias}
                    />
                    <Select className="custom-selector" />
                  </div>
                  {formik.touched.alias && formik.errors.alias ? (
                    <div className="error">{formik.errors.alias}</div>
                  ) : null}
                </div>
              </div>
            </div>
          </div>
          <div className="d-flex justify-content-end gap-2 mt-2">
            {/* <button className="btn btn-primary text-xs" type="submit" disabled={isSubmitting}>
                            {isSubmitting ? <i className="fa fa-spinner fa-spin" /> : "Submit"}
                        </button> */}
            <button
              className="btn btn-primary text-xs"
              type="submit"
              onClick={handleClose}
            >
              Submit
            </button>
            <button
              className="btn btn-primary text-xs"
              type="submit"
              onClick={handleClose}
            >
              Save & Close
            </button>
            <button
              className="btn btn-primary text-xs"
              type="submit"
              onClick={handleClose}
            >
              Save & New
            </button>
            <button
              className="btn btn-light text-xs"
              type="submit"
              onClick={handleClose}
            >
              Close
            </button>
          </div>
        </form>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default AddMaster;
